
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/college/[college]/[sport]/[year]/commits",
      function () {
        return require("private-next-pages/college/[college]/[sport]/[year]/commits.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/college/[college]/[sport]/[year]/commits"])
      });
    }
  